import type { FiscalQuota } from "@/domain/beneficiary";
import { InvestmentState, type InvestmentResponse } from "@/domain/investment/types";
import {
  deductionOf,
  investmentCapacityAt,
  investmentLeft,
  investmentRoom,
} from "./fiscalCalculations";

export interface InvestmentCapacityPreview {
  completed: string;
  reserved: string;
  room: string | null;
  total: string | null;
  left: string | null;
  transferredDeduction: string | null;
}

export const ownDeductionOf = (investment: InvestmentResponse | null | undefined): string =>
  investment && investment.state !== InvestmentState.PROSPECT ? investment.deduction : "0";

export function quotaRoom(
  quota: FiscalQuota | null,
  returnPercentage: string,
  editing?: InvestmentResponse | null,
): string | null {
  if (!quota) return null;
  return investmentRoom(quota.money.deduction.available, returnPercentage, ownDeductionOf(editing));
}

export function investmentCapacityPreview(
  quota: FiscalQuota | null,
  amount: string,
  returnPercentage: string,
  editing?: InvestmentResponse | null,
): InvestmentCapacityPreview | null {
  if (!quota) return null;
  const room = quotaRoom(quota, returnPercentage, editing);
  const { completed, reserved } = quota.money.investment;
  return {
    completed,
    reserved,
    room,
    total: room === null ? null : investmentCapacityAt(completed, reserved, room),
    left: room === null ? null : investmentLeft(room, amount || "0"),
    transferredDeduction: deductionOf(amount || "0", returnPercentage),
  };
}
